<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      الفواتير التي لم يتم الموافقة عليها بعد

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>
            <td style="padding:0px">
              <v-btn
                small
                color="orange"
                style="margin:0px;padding:0px"
                @click.prevent="add_serial_before_confirm(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                تاكيد
              </v-btn>
              <v-btn
                small
                color="red"
                style="margin:4px 0px;padding:0px"
                @click.prevent="taslim_reject(props.item)"
              >
                <!-- @click="confirm_fatwora" -->
                رفض
              </v-btn>
            </td>
            <td>
              <textarea v-model="props.item.reason" name="" id=""></textarea>
            </td>
            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
            <td>
              <v-icon
                style="curser:pointer"
                v-if="permissions.delete_all == 1 || user.type == 1"
                @click="delete_fatwora(props.item)"
                >delete</v-icon
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination.page"
          :length="pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-container>
      الفواتير التي تمت الموافقة عليها من قبل

      <v-data-table
        :headers="headers5"
        :items="fatworas_confirmed"
        class="elevation-1"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination_confirmed"
      >
        <template slot="items" slot-scope="props">
          <tr style="background-color :yellow">
            <td>{{ props.item.code }}</td>
            <td class="text-xs-right">{{ props.item.price_after }}</td>
            <td class="text-xs-right">{{ props.item.client_name }}</td>
            <td class="text-xs-right">{{ props.item.taslim_date }}</td>
            <td class="text-xs-right">{{ props.item.created_at }}</td>
            <td class="justify-center layout px-0">
              <v-icon small class="ml-4" @click="detailItem(props.item)">
                book
              </v-icon>
            </td>

            <td>
              <router-link :to="'/FinalFatworasPrint/' + props.item.id"
                ><v-icon>print</v-icon></router-link
              >
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
        <template slot="no-data">
          <v-btn color="primary" @click="initialize">Reset</v-btn>
        </template>
      </v-data-table>
      <div class="text-xs-center pt-2">
        <v-pagination
          dark
          dir="rtl"
          class="mypagination"
          v-model="pagination_confirmed.page"
          :length="pagination_confirmed_pages"
          prev-icon="chevron_right"
          next-icon="chevron_left"
        ></v-pagination>
      </div>
    </v-container>

    <v-dialog v-model="detail_dialog" width="800" dark style="padding:10px">
      <v-card>
        <v-card-title class="headline orange lighten-2" primary-title>
         ادخال السيريالات قبل التاكيد
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              الكود :
              {{ item_detail.code }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المندوب :
              {{
                item_detail.client && item_detail.client.mandob_sales
                  ? item_detail.client.mandob_sales.name
                  : ""
              }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              اسم العميل :
              {{ item_detail.client_name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السعر قبل :
              {{ item_detail.price_before }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السعر بعد :
              {{ item_detail.price_after }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              نوع السداد :
              {{ item_detail.sdad_type_name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              موظف عمل الفاتورة :
              {{ item_detail.emp_create_fatwora }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              تاريخ التسليم :
              {{ item_detail.taslim_date }}
            </v-flex>
          </v-layout>
          <hr />
          <v-data-table
            :headers="headers3"
            :items="item_detail.fatwora_items"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_num }}</td>
              <td>{{ props.item.item_num_after }}</td>
              <td>{{ props.item.item_bonus }}</td>
              <td>{{ props.item.serial_from }}</td>
              <td>{{ props.item.serial_to }}</td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="detail_dialog = false">
            موافق
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_serials" width="800" dark style="padding:10px">
      <v-card>
        <v-card-title class="headline orange lighten-2" primary-title>
          تفاصيل فاتورة مبيعات
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm6 md4>
              الكود :
              {{ add_serials_detail.code }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              المندوب :
              {{
                add_serials_detail.client && add_serials_detail.client.mandob_sales
                  ? add_serials_detail.client.mandob_sales.name
                  : ""
              }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              اسم العميل :
              {{ add_serials_detail.client_name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السعر قبل :
              {{ add_serials_detail.price_before }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              السعر بعد :
              {{ add_serials_detail.price_after }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              نوع السداد :
              {{ add_serials_detail.sdad_type_name }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              موظف عمل الفاتورة :
              {{ add_serials_detail.emp_create_fatwora }}
            </v-flex>
            <v-flex xs12 sm6 md4>
              تاريخ التسليم :
              {{ add_serials_detail.taslim_date }}
            </v-flex>
          </v-layout>
          <hr />
          <v-data-table
            :headers="headers31"
            :items="add_serials_detail.fatwora_items"
            class="elevation-1"
            :rows-per-page-items="rowsPerPageItems"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.item_name }}</td>
              <td>{{ props.item.item_num }}</td>
              <td><input type="text" v-model="props.item.serial_from"></td>
              <td><input type="text" v-model="props.item.serial_to"></td>
            </template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="add_serials = false">
            الغاء
          </v-btn>
          <v-btn color="primary" flat @click="taslim_confirm">
            التأكيد علي التحويل بعد ادخال السيريال
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  log_me,
  delete_fatwora_client_before_store,
  taslim_fatworas,
  taslim_confirm,
  taslim_reject,
  add_fatwora,
  delete_fatwora,
  madionia_client,
  search_client_by_code
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    add_dialog: false,
    edit_dialog: false,
    dialog: false,

    date: new Date().toISOString().substr(0, 10),
    menu: false,
    modal: false,
    menu2: false,
    item_detail: {},
    detail_dialog: false,
    add_serials: false,
    add_serials_detail: {},

    select_sadad_type: { id: "", job_name: "", name: "أختر نوع السداد" },
    select_client: { id: "", job_name: "", name: "أختر المورد" },
    select_employer: { id: "", job_name: "", name: "أختر المسئول" },
    select_store: { id: "", job_name: "", name: "أختر المخزن" },
    select_item: { id: "", job_name: "", name: "أختر الصنف" },
    select_sadadstatuses: { name: "" },

    search: "",
    loading: true,
    pagination: {
      rowsPerPage: 30,
      descending: true
    },
    pagination_confirmed: {
      rowsPerPage: 30,
      descending: true
    },
    headers: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: " التاريخ", value: "taslim_date", align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " تأكيد", value: "store", sortable: false, align: "right" },
      { text: " سبب الرفض", value: "store", sortable: false, align: "right" },
      {
        text: " تعين وطباعة ",
        value: "store",
        sortable: false,
        align: "right"
      },
      { text: "حذف ", value: "store", sortable: false, align: "right" }
    ],
    headers5: [
      {
        text: "الكود ",
        align: "right",
        value: "code"
      },
      { text: "السعر ", value: "price_after", align: "right" },
      { text: " اسم العميل", value: "client_name", align: "right" },
      { text: "  تاريخ التسليم", value: "taslim_date", align: "right" },
      { text: " التاريخ", value: "taslim_date", align: "right" },
      { text: " تفاصيل", value: "store", sortable: false, align: "right" },
      { text: " تعين وطباعة ", value: "store", sortable: false, align: "right" }
    ],
    headers3: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: " العدد النهائي",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: "   البونص",
        value: "item_bonus",
        sortable: false,
        align: "right"
      },
      {
        text: "   سيريال من",
        value: "item_bonus",
        sortable: false,
        align: "right"
      },
      {
        text: "   سيريال الي",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],
    headers31: [
      {
        text: "الصنف ",
        align: "right",
        value: "item"
      },
      { text: " العدد", value: "client_name", sortable: false, align: "right" },
      {
        text: "سيريال من",
        value: "item_num_after",
        sortable: false,
        align: "right"
      },
      {
        text: " سيريال الي",
        value: "item_bonus",
        sortable: false,
        align: "right"
      }
    ],

    fatworas: [],
    fatworas_confirmed: [],
    m_sadad_types: [],
    m_employers: [],
    clients: [],
    m_items: [],
    stores: [],
    client_search_name: "",
    sadadstatuses: [],
    newItem: {
      id: "",
      code: "",
      madionia_sabqa: "",
      madionia_now: "",
      discount: "",
      price_before: "",
      price_after: "",
      sdad_type_name: "",
      sdad_status: "",
      emp_bill_amr: "",
      emp_create_fatwora: "",
      emp_sales_response_name: "",
      client_name: "",
      taslim_date: "",
      store_id: "",
      sadad_type_id: "",
      client_id: "",
      emp_sales_response_id: ""
    },
    madionia: {
      madionia_before: "",
      cost_or_money: "",
      madionia_after: "",
      emp_name: "",
      type_of_operation: "",
      code_of_operation: "",
      client_id: "",
      emp_id: ""
    },
    added_items: [],
    madionia_sabqa_of_madionia: ""
  }),

  computed: {
    mycode() {
      if (this.fatworas.length > 0) {
        return (this.code =
          parseInt(this.fatworas[this.fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    pages() {
      if (
        this.pagination.rowsPerPage == null ||
        this.pagination.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination.totalItems / this.pagination.rowsPerPage
      );
    },
    pagination_confirmed_pages() {
      if (
        this.pagination_confirmed.rowsPerPage == null ||
        this.pagination_confirmed.totalItems == null
      )
        return 0;

      return Math.ceil(
        this.pagination_confirmed.totalItems /
          this.pagination_confirmed.rowsPerPage
      );
    },
    gettotalpriceitem: function() {
      return function(q, p) {
        return parseInt(q) * parseFloat(p);
      };
    },
    get_item_num_after: function() {
      return function(n, b) {
        if (b != 0) {
          return parseInt(n) + parseFloat(b);
        }
        return parseInt(n);
      };
    },
    get_item_final_price: function() {
      return function(p, d) {
        if (d != "") {
          return parseFloat(p) - parseFloat(d);
        }
        return parseFloat(p);
      };
    },

    fatwora_price() {
      let tot_price = 0;
      for (let index = 0; index < this.added_items.length; index++) {
        tot_price += parseFloat(this.added_items[index].total_price);
      }
      return (this.newItem.price_before = tot_price);
    },
    fatwora_final_price() {
      if (this.newItem.price_before != "" && this.newItem.discount != "") {
        return (this.newItem.price_after =
          parseFloat(this.newItem.price_before) -
          parseFloat(this.newItem.discount));
      }
      return (this.newItem.price_after = this.newItem.price_before);
    },
    madionia_now() {
      if (this.newItem.price_after > 0) {
        return (this.newItem.madionia_now =
          parseFloat(this.newItem.madionia_sabqa) +
          parseFloat(this.newItem.price_after));
      }
      return (this.newItem.madionia_now = this.newItem.madionia_sabqa);
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    // this.initialize()
    //  sadadtypes().then((response)=>{
    //          this.m_sadad_types=response.data
    //               });

    // employers().then((response)=>{
    //   this.m_employers=response.data
    // })

    // items().then((response)=>{
    //   this.m_items=response.data
    // })

    // clients().then((response)=>{
    //   this.clients=response.data
    // })

    taslim_fatworas().then(response => {
      this.fatworas = response.data.fatworas;
      this.fatworas_confirmed = response.data.fatworas_confirmed;
      this.pagination.totalItems = response.data.fatworas.length;
      this.pagination_confirmed.totalItems =
        response.data.fatworas_confirmed.length;
      this.loading = false;
    });

    // stores().then((response)=>{
    //   this.stores=response.data

    // })

    // sadadstatuses().then((response)=>{
    //   this.sadadstatuses=response.data

    // })
  },

  methods: {
    initialize() {},

    add_item() {
      this.added_items.push({
        item_name: this.select_item.name,
        item_num_before: "",
        item_num: 1,
        item_num_after: "",
        item_discount: "",
        item_bonus: "",
        price: this.select_item.price_sell,
        total_price: this.select_item.total_price,
        final_price: this.select_item.final_price,
        item_id: this.select_item.id
      });
      this.select_item = { id: "" };
    },
    remove_item(item) {
      const index = this.added_items.indexOf(item);
      this.added_items.splice(index, 1);
    },
    change_client_name() {
      this.newItem.client_name = this.select_client.name;
      madionia_client(this.select_client.id).then(response => {
        this.newItem.madionia_sabqa = response.data.madionia;
        this.madionia_sabqa_of_madionia = response.data.madionia;
      });
    },
    change_employer_name() {
      this.newItem.emp_sales_response_name = this.select_employer.name;
    },
    change_sadad_name() {
      this.newItem.sdad_type_name = this.select_sadad_type.name;
    },
    deleteItem(item) {
      this.$swal({
        title: "هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          delete_fatwora(item.id).then(response => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    delete_fatwora(item) {
      this.$swal({
        title:
          "شرط لحذف الفاتورة ان تكون اخر فاتورة لنفس العميل حتي لا تؤثر علي المديونية ..هل تريد الأستمرار",
        text: "سيتم الحذف نهائيا ولا يمكن الرجوع",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "نعم !",
        cancelButtonText: "لا"
      }).then(result => {
        if (result.value) {
          const index = this.fatworas.indexOf(item);

          this.loading = true;
          delete_fatwora_client_before_store(item.id).then(res => {
            this.loading = false;
            this.fatworas.splice(index, 1);
            this.close();
          });
        }
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
    },

    save(scope) {
      this.$validator.validateAll(scope).then(valid => {
        if (valid) {
          this.loading = true;
          let myUser = JSON.parse(localStorage.getItem("user"));
          this.newItem.code = this.code;
          this.newItem.sadad_type_id = this.select_sadad_type.id;
          this.newItem.client_id = this.select_client.id;
          this.newItem.emp_sales_response_id = myUser.id;
          this.newItem.store_id = this.select_store.id;
          this.newItem.sdad_status = this.select_sadadstatuses.name;
          this.newItem.taslim_date = this.date;
          this.newItem.status = "1";
          this.newItem.emp_fatwora_taslim = myUser.name;

          this.madionia.madionia_before = this.newItem.madionia_sabqa;
          this.madionia.cost_or_money = this.newItem.price_after;
          this.madionia.madionia_after = this.newItem.madionia_now;
          this.madionia.emp_name = myUser.name;
          this.madionia.type_of_operation = "fatwora";
          this.madionia.code_of_operation = this.newItem.code;
          this.madionia.client_id = this.select_client.id;
          this.madionia.emp_id = myUser.id;

          var frmData = new FormData();
          frmData.append("fatwora", JSON.stringify(this.newItem));
          frmData.append("fatwora_items", JSON.stringify(this.added_items));
          frmData.append("madionia", JSON.stringify(this.madionia));

          add_fatwora(frmData).then(response => {
            Object.assign(this.$data.newItem, this.$options.data().newItem);
            // Object.assign(this.$data.select_sadad_type, this.$options.data().select_sadad_type);
            // Object.assign(this.$data.select_client, this.$options.data().select_client);
            // Object.assign(this.$data.select_employer, this.$options.data().select_employer);
            // Object.assign(this.$data.added_items, this.$options.data().added_items);
            // Object.assign(this.$data.select_item, this.$options.data().select_item);
            this.fatworas.push(response.data);
            this.loading = false;
            this.close();
            setTimeout(() => {
              this.$refs.form.reset();
            }, 1000);
          });
        }
      });
    },

    search_client_by_code() {
      search_client_by_code(this.client_search_name).then(response => {
        this.select_client = response.data;
        this.change_client_name();
      });
    },

    add_serial_before_confirm(item) {
      this.add_serials_detail=item
      this.add_serials = true
    },

    taslim_confirm() {
      var frmData = new FormData();
      let myUser = JSON.parse(localStorage.getItem("user"));
      frmData.append("emp_fatwora_taslim", myUser.name);
      frmData.append("fatwora", JSON.stringify(this.add_serials_detail));
      this.loading = true;
      taslim_confirm(this.add_serials_detail.id, frmData).then(response => {
        this.add_serials = false
        this.loading = false;
        const index = this.fatworas.indexOf(this.add_serials_detail);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "التاكيد علي فاتورة في حالة قيد التسليم");
        frmData3.append(
          "body",
          "تم التاكيد علي فاتورة في حالة قيد التسليم " +
            this.select_store.name +
            " لفاتورة بكود " +
            this.add_serials_detail.code +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "taslim_confirm");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "التاكيد علي فاتورة في حالة قيد التسليم";
            let mybody =
              "تم التاكيد علي فاتورة في حالة قيد التسليم  " +
              this.select_store.name +
              " لفاتورة بكود " +
              this.add_serials_detail.code +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }

          setTimeout(() => {
            this.$router.go(0);
          }, 2000);
        });
      });
    },
    taslim_reject(item) {
      var frmData = new FormData();
      frmData.append("reason", item.reason);
      taslim_reject(item.id, frmData).then(response => {
        const index = this.fatworas.indexOf(item);
        this.fatworas.splice(index, 1);
        let myUser = JSON.parse(localStorage.getItem("user"));
        var frmData3 = new FormData();
        frmData3.append("title", "الرفض علي فاتورة في حالة قيد التسليم");
        frmData3.append(
          "body",
          "تم الرفض علي فاتورة في حالة قيد التسليم " +
            this.select_store.name +
            " لفاتورة بكود " +
            item.code +
            " بواسطة " +
            myUser.name
        );
        frmData3.append("type", "taslim__reject");
        frmData3.append("user_id", myUser.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "الرفض علي فاتورة في حالة قيد التسليم";
            let mybody =
              "تم الرفض علي فاتورة في حالة قيد التسليم  " +
              this.select_store.name +
              " لفاتورة بكود " +
              item.code +
              " بواسطة " +
              myUser.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
          }
        });
      });
    },
    detailItem(order) {
      this.item_detail = order;
      this.detail_dialog = true;
    }
  }
};
</script>

<style scope>
.v-datatable__actions {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.flex,
.v-input.v-text-field,
.v-input__control {
  padding: 0px !important;
  margin: 0px !important;
}
.v-card__title,
.v-card__text {
  padding: 0px;
  margin: 0px;
}
</style>
